import React from "react";
import jet from "@randajan/jet-react";
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import { Chip } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

import { Say } from "../../../../../arc/locale/consts.js";
import { formatProfileAddress, formatProfileDate, hasProfileValue, toProfileText } from "../profilePrivateTools";

import "./PersonalPanel.scss";
import { usePagePop } from "../../../PagePops/PagePops";
import { Locale } from "../../../../assets/Locale.js";

const personalRows = Object.freeze([
    { field:"name", icon:PersonOutlineOutlinedIcon, format:toProfileText },
    { field:"email", icon:EmailOutlinedIcon, format:toProfileText },
    { field:"phone", icon:PhoneOutlinedIcon, format:toProfileText },
    { field:"birthday", icon:EventOutlinedIcon, format:formatProfileDate },
    { field:"locale", icon:LanguageOutlinedIcon, format:toProfileText },
    { field:"country", icon:PublicOutlinedIcon, format:toProfileText },
    { field:"address", icon:HomeOutlinedIcon, format:formatProfileAddress }
]);

const formatLocale = (say, value)=>{
    if (!hasProfileValue(value)) { return toProfileText(value); }

    const key = String(value).trim().toLowerCase();
    return say.or(Say.id("locale", key), String(value));
};

const getRowValue = (say, row, profile)=>{
    if (row.field === "address") { return row.format(profile); }
    if (row.field === "locale") { return formatLocale(say, profile[row.field]); }
    return row.format(profile[row.field]);
};

export const PersonalPanel = (props)=>{
    const { profile={} } = props;
    const pop = usePagePop("personalForm");
    const say = Locale.use();

    return (
        <Block tagName="section" className="PersonalPanel wall -form">
            <div className="header">
                <Caption>{say("profilePersonalCaption")}</Caption>
                <Chip
                    className="BlimpMuiPanel-status"
                    icon={<LockOutlinedIcon />}
                    label={say("profilePersonalPrivate")}
                    variant="outlined"
                />
            </div>
            <ul className="iconized">
                {personalRows.map(row=>{
                    const Icon = row.icon;
                    const value = getRowValue(say, row, profile);

                    return (
                        <li key={row.field}>
                            <Icon fontSize="small" />
                            <p className="fieldLabel">{say(Say.id("profile", "field", row.field))}</p>
                            <p className={jet.melt(["fieldValue", value === "-" ? "font -fade" : ""], " ")}>{value}</p>

                        </li>
                    );
                })}
            </ul>
            <section className="controls">{pop?.button}</section>
        </Block>
    );
};
